import api from '@/api';

export default {
	/**
	 * 교보문고 커스텀 웹파트를 삭제합니다.
	 * @param id 웹파트 아이디
	 * @param component 웹파트 컴포넌트 이름
	 * @returns 
	 */
	deleteKBWebpart(id: string, component: string): Promise<boolean> {
        return api.delete<boolean>({
            url: `/Webpart/WebpartData/api/KBB/delete?id=${id}&component=${component}`,
        })
	},

	/**
	 * 웹파트에 등록된 바로가기 링크 목록을 조회합니다.
	 * @param webpartId 링크를 조회할 웹파트 아이디
	 * @returns 
	 */
	getShortcutList(webpartId: string): Promise<kyobobook.Shortcut[]> {
		return api.get({
			url: `/Webpart/WebpartShortcut/api/KBB/getList?webpartId=${webpartId}`,
		});
	},

	/**
	 * 웹파트에 등록된 바로가기 링크 목록을 IsMain 조건에 따라 조회합니다. (단, IsUse = true)
	 * @param webpartId 링크를 조회할 웹파트 아이디
	 * @param isMain 링크의 메인 표시 여부
	 * @returns 
	 */
	getShortcutListByMain(webpartId: string, isMain: boolean): Promise<kyobobook.Shortcut[]> {
		return api.get({
			url: `/Webpart/WebpartShortcut/api/KBB/getListByMain?webpartId=${webpartId}&isMain=${isMain}`,
		});
	},

	/**
	 * 웹파트에 등록된 바로가기 링크 목록을 조회합니다. (IsUse 상관없이 모두)
	 * @param webpartId 링크를 조회할 웹파트 아이디
	 * @returns 
	 */
	getShortcutListAdmin(webpartId: string): Promise<kyobobook.Shortcut[]> {
		return api.get({
			url: `/Webpart/WebpartShortcut/api/KBB/getListAdmin?webpartId=${webpartId}`,
		});
	},

	/**
	 * 웹파트에 등록된 카테고리 목록을 조회합니다.
	 * @param webpartId 카테고리를 조회할 웹파트 아이디
	 * @returns 
	 */
	getShortcutCategoryList(webpartId: string): Promise<kyobobook.ShortcutCategory[]> {
		return api.get({
			url: `/Webpart/WebpartShortcut/api/KBB/getCategoryList?webpartId=${webpartId}`
		})
	},

	/**
	 * 웹파트에 등록된 바로가기 링크를 생성합니다.
	 * @param shortcutInfo 바로가기 링크 데이터
	 * @returns 
	 */
	createShortcut(shortcutInfo: kyobobook.Shortcut): Promise<number> {
		return api.post({
			url: '/Webpart/WebpartShortcut/api/KBB/createShortcut',
			data: shortcutInfo
		})
	},

	/**
	 * 웹파트에 등록된 바로가기 링크를 수정합니다.
	 * @param shortcutInfo 바로가기 링크 데이터
	 * @returns 
	 */
	updateShortcut(shortcutInfo: kyobobook.Shortcut): Promise<number> {
		return api.post({
			url: '/Webpart/WebpartShortcut/api/KBB/updateShortcut',
			data: shortcutInfo
		})
	},

	/**
	 * 웹파트에 등록된 바로가기 링크를 삭제합니다.
	 * @param webpartId 웹파트 아이디
	 * @param shortcutId 바로가기 링크 아이디
	 * @returns 
	 */
	deleteShortcut(webpartId: string, shortcutId: number): Promise<number> {
		return api.delete({
			url: `/Webpart/WebpartShortcut/api/KBB/deleteShortcut?webpartId=${webpartId}&shortcutId=${shortcutId}`
		})
	},

	/**
	 * 바로가기에 대한 카테고리를 생성합니다.
	 * @param categoryInfo 카테고리 데이터
	 * @returns 
	 */
	createCategory(categoryInfo: kyobobook.ShortcutCategory): Promise<number> {
		return api.post({
			url: '/Webpart/WebpartShortcut/api/KBB/createCategory',
			data: categoryInfo
		})
	},

	/**
	 * 바로가기에 대한 카테고리를 수정합니다.
	 * @param categoryInfo 카테고리 데이터
	 * @returns 
	 */
	updateCategory(categoryInfo: kyobobook.ShortcutCategory): Promise<number> {
		return api.post({
			url: '/Webpart/WebpartShortcut/api/KBB/updateCategory',
			data: categoryInfo
		})
	},

	/**
	 * 바로가기에 대한 카테고리를 삭제합니다.
	 * @param webpartId 웹파트 아이디
	 * @param categoryId 카테고리 아이디
	 * @returns 
	 */
	deleteCategory(webpartId: string, categoryId: number): Promise<number> {
		return api.delete({
			url: `/Webpart/WebpartShortcut/api/KBB/deleteCategory?webpartId=${webpartId}&categoryId=${categoryId}`
		})
	},

	/**
	 * 바로가기에 대한 카테고리의 순서를 변경합니다.
	 * @param set 
	 * @returns 
	 */
	swapCategoryOrder(set: kyobobook.CategoryOrderSwapSet): Promise<number> {
		return api.post({
			url: '/Webpart/WebpartShortcut/api/KBB/updateCategoryOrder',
			data: set
		})
	},

	/**
	 * 바로가기의 순서를 변경합니다.
	 * @param set 
	 * @returns 
	 */
	swapOrder(set: kyobobook.OrderSwapSet): Promise<number> {
		return api.post({
			url: '/Webpart/WebpartShortcut/api/KBB/updateOrder',
			data: set
		})
	},

	/**
	 * 웹파트에 등록된 이미지 리스트를 조회합니다. (IsUse 상관없이 모두)
	 * @param webpartId 웹파트 아이디
	 * @returns 
	 */
	getImageListAdmin(webpartId: string): Promise<kyobobook.Image[]> {
		return api.get({
			url: `/Webpart/WebpartImage/api/getListAdmin?webpartId=${webpartId}`,
		});
	},

	/**
	 * 웹파트에 등록된 이미지 중 사용 중인 이미지 리스트를 조회합니다.
	 * @param webpartId 웹파트 아이디
	 * @returns 
	 */
	getImageList(webpartId: string): Promise<kyobobook.Image[]> {
		return api.get({
			url: `/Webpart/WebpartImage/api/getList?webpartId=${webpartId}`,
		});
	},

	/**
	 * 웹파트에 등록된 이미지 중 하나를 랜덤하게 조회합니다.
	 * @param webpartId 웹파트 아이디
	 * @returns 
	 */
	getRandomImageInfo(webpartId: string): Promise<kyobobook.Image> {
		return api.get({
			url: `/Webpart/WebpartImage/api/getRandomImageInfo?webpartId=${webpartId}`,
		});
	},

	/**
	 * 웹파트에 등록된 이미지 데이터를 생성합니다.
	 * @param imageInfo 이미지 데이터
	 * @returns 
	 */
	createImage(imageInfo: kyobobook.Image): Promise<number> {
		return api.post({
			url: '/Webpart/WebpartImage/api/create',
			data: imageInfo
		})
	},

	/**
	 * 웹파트에 등록된 이미지 데이터를 수정합니다.
	 * @param imageInfo 이미지 데이터
	 * @returns 
	 */
	updateImage(imageInfo: kyobobook.Image): Promise<number> {
		return api.post({
			url: '/Webpart/WebpartImage/api/update',
			data: imageInfo
		})
	},

	/**
	 * 웹파트에 등록된 이미지 데이터를 삭제합니다.
	 * @param webpartId 웹파트 아이디
	 * @param id 이미지 아이디
	 * @returns 
	 */
	deleteImage(webpartId: string, id: number): Promise<number> {
		return api.delete({
			url: `/Webpart/WebpartImage/api/delete?webpartId=${webpartId}&id=${id}`
		})
	},

	/**
	 * 전자결재 미결함 데이터를 조회합니다.
	 * @param req 조회조건
	 * @returns 
	 */
	getDocumentBoxItemList(req: kyobobook.WorkflowRequestDocumentBox) {
        return api.post<kyobobook.WorkflowResponseDocumnetBoxItem>({
            url: "/workflow/documentbox/api/itemlist",
            data: req,
        });
	},

	addClickCount(webpartId: string, shorcutId: number): Promise<number> {
		return api.get({
			url: `/Webpart/WebpartShortcut/api/KBB/addClickCount?webpartId=${webpartId}&shortcutId=${shorcutId}`
		})
	}
};
